import React from "react";
import getClassNameFactory from "../../utilities/classNames";

var Svg = function Svg(_ref) {
  var children = _ref.children,
      focusable = _ref.focusable,
      height = _ref.height,
      label = _ref.label,
      width = _ref.width;
  var getClassName = getClassNameFactory(Svg.displayName);
  var baseFontSize = 16;
  /* eslint-disable no-undefined */

  var svg = /*#__PURE__*/React.cloneElement(children, {
    "aria-hidden": label ? undefined : true,
    "aria-label": label,
    role: label ? "img" : undefined,
    focusable: focusable
  });
  /* eslint-enable no-undefined */

  var svgProps = {
    className: getClassName()
  };
  var innerProps = {
    className: getClassName({
      descendantName: "inner"
    })
  };

  if (width) {
    svgProps.style = {
      width: "".concat(width / baseFontSize, "rem")
    };
  }
  /* eslint-disable no-magic-numbers */


  if (height && width) {
    innerProps.style = {
      paddingBottom: "".concat(height / width * 100, "%")
    };
  }
  /* eslint-enable no-magic-numbers */


  return /*#__PURE__*/React.createElement("span", svgProps, /*#__PURE__*/React.createElement("span", innerProps, svg));
};

Svg.displayName = "Svg";
export default Svg;